export const dateFilterElement = ({ value, filterCallback }) => (
    <input
        type='date'
        className='form-control'
        value={value}
        onChange={(e) => filterCallback(e.target.value)}
    />
)
